<template>
  <div class="step">
    <div class="step__question-group">
      <FormBaseTextarea
        v-model="message"
        name="message"
        label="Use the field below to share any additional comments or feedback."
        label-bold
      />
    </div>
    <p class="step__email-disclaimer">
      Your feedback will be sent as {{ email }}.
    </p>
  </div>
</template>

<script lang="ts" setup>
const message = defineModel<string>('message')

const { query } = useRoute()
const email = query.email as string
</script>

<style lang="scss" scoped>
.step {
  &__question {
    font-size: var(--font-size-paragraph-s);
    font-weight: 600;
    margin-bottom: 32px;
    line-height: 26px;

    &::after {
      content: '*';
      color: var(--red-500);
    }
  }

  &__question-group {
    margin-bottom: 48px;
  }

  &__email-disclaimer {
    font-size: var(--font-size-paragraph-xs);
    line-height: 24px;
    text-align: center;
    margin-bottom: 0;
  }
}
</style>
